var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 3.5C8.8375 3.5 9.625 2.7125 9.625 1.75C9.625 0.7875 8.8375 0 7.875 0C6.9125 0 6.125 0.7875 6.125 1.75C6.125 2.7125 6.9125 3.5 7.875 3.5ZM7.875 5.25C6.9125 5.25 6.125 6.0375 6.125 7C6.125 7.9625 6.9125 8.75 7.875 8.75C8.8375 8.75 9.625 7.9625 9.625 7C9.625 6.0375 8.8375 5.25 7.875 5.25ZM7.875 10.5C6.9125 10.5 6.125 11.2875 6.125 12.25C6.125 13.2125 6.9125 14 7.875 14C8.8375 14 9.625 13.2125 9.625 12.25C9.625 11.2875 8.8375 10.5 7.875 10.5Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.5C2.7125 3.5 3.5 2.7125 3.5 1.75C3.5 0.7875 2.7125 0 1.75 0C0.7875 0 0 0.7875 0 1.75C0 2.7125 0.7875 3.5 1.75 3.5ZM1.75 5.25C0.7875 5.25 0 6.0375 0 7C0 7.9625 0.7875 8.75 1.75 8.75C2.7125 8.75 3.5 7.9625 3.5 7C3.5 6.0375 2.7125 5.25 1.75 5.25ZM1.75 10.5C0.7875 10.5 0 11.2875 0 12.25C0 13.2125 0.7875 14 1.75 14C2.7125 14 3.5 13.2125 3.5 12.25C3.5 11.2875 2.7125 10.5 1.75 10.5Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.21252704fa58b9d57b3c3fc02e432407.svg";
export { ForwardRef as ReactComponent };